import { render, staticRenderFns } from "./HomeProfile.vue?vue&type=template&id=21b1480b"
import script from "./HomeProfile.vue?vue&type=script&lang=js"
export * from "./HomeProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports